var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9241 6.38297C15.9998 6.20019 16.0196 5.99907 15.981 5.80505C15.9424 5.61102 15.847 5.43281 15.7071 5.29297L10.7071 0.292969L9.29312 1.70697L12.5861 4.99997H0.000115853V6.99997H15.0001C15.1979 7.00002 15.3912 6.94143 15.5557 6.8316C15.7202 6.72178 15.8484 6.56565 15.9241 6.38297ZM0.0761161 9.61697C0.000411265 9.79974 -0.0193799 10.0009 0.019247 10.1949C0.057874 10.3889 0.153183 10.5671 0.293116 10.707L5.29312 15.707L6.70712 14.293L3.41412 11H16.0001V8.99997H1.00012C0.80232 8.99979 0.608922 9.05832 0.444428 9.16817C0.279935 9.27801 0.15175 9.4342 0.0761161 9.61697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapping);
export default __webpack_public_path__ + "static/media/mapping.3328579cbce55cd277870e68423ea410.svg";
export { ForwardRef as ReactComponent };